import { connect } from "react-redux";
import ClientOverview from "./ClientOverview";
import {
  getClientDetails,
  deleteClientRequest,
  updateClientRequest,
} from "../../../store/actions/clients.actions";
import {
  client,
  loader,
  overviewLoader,
} from "../../../store/selectors/clients.selector";

const mapDispatchToProps = {
  getClientDetails,
  deleteClientRequest,
  updateClientRequest,
};

const mapStateToProps = (state) => {
  const clientData = client(state);
  const loading = loader(state);
  const clientLoading = overviewLoader(state);
  return { clientData, loading, clientLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientOverview);
